/* ══════════════════════════════════════════════════════════════════
   点了才加载的视频 —— 全站唯一一份

   **YouTube / Vimeo 永远不在页面加载时嵌进来。** 两个理由都不是洁癖：
   一个 iframe 是一整套播放器（几百 KB 脚本），而这是欧洲店 ——
   嵌进来那一刻第三方 cookie 就写下去了，同意横幅还没点。
   一节里有三条测评就是三次外站握手，页面还没读到那儿钱已经花在带宽上。

   契约三件：
     `[data-video]`       装播放器的那个盒子，`data-video` 是 id
     `[data-video-type]`  youtube（默认）/ vimeo
     `[data-video-start]` 从第几秒开始（可选，操作指南页的章节用）
     `[data-play]`        播放键

   **怎么找到该播哪一个**：默认在 `btn.parentElement` 里找 —— 零件套件和
   产品页的故事都是「键和盒子是兄弟」。一节里有好几条视频、而键和盒子不是
   兄弟时（评测墙），给它们共同的祖先加 `data-video-scope`。

   这份文件是把三份一样的实现合成的一份（2026-08-06）：
   `component-blocks.js` 里一份、`section-story.js` 里一份，评测墙本来要写
   第三份 —— 零件套件的注释里早就写着「两处以后要合成一份」，评测墙就是
   那个第三处。行为按最全的那份取：加 `is-playing`、移走播放键、
   移走时长角标；三种写法原来各做其中两件，合起来互不冲突。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-play]');
    if (!btn) return;

    var scope = btn.closest('[data-video-scope]') || btn.parentElement;
    if (!scope) return;

    /* 状态给最近的那层：零件套件读 `.eb-video.is-playing`，
       评测墙读自己那一格 —— 两个都靠这一行拿到 class。 */
    (btn.closest('.eb-video') || scope).classList.add('is-playing');

    /* 自托管视频（Shopify 自己存的）本来就在 DOM 里，没有第三方问题，放就完了 */
    var native = scope.querySelector('video');
    if (native) { native.play(); btn.remove(); return; }

    var media = scope.querySelector('[data-video]');
    if (!media) return;

    var id = media.dataset.video;
    /* 从第几秒开始 —— 操作指南页的章节点一下就是从那一步开始播。
       两家的写法不一样：YouTube 是 `start=` 参数，Vimeo 是 `#t=Ns` 片段。
       没写这个属性的照旧从头播，所以评测墙那边一行都不用改。 */
    var start = parseInt(media.dataset.videoStart, 10) || 0;
    var src = media.dataset.videoType === 'vimeo'
      ? 'https://player.vimeo.com/video/' + id + '?autoplay=1' + (start ? '#t=' + start + 's' : '')
      : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0' + (start ? '&start=' + start : '');

    var frame = document.createElement('iframe');
    frame.src = src;
    frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
    frame.setAttribute('loading', 'lazy');
    media.innerHTML = '';
    media.appendChild(frame);

    btn.remove();
    var len = scope.querySelector('.eb-story__len');
    if (len) len.remove();
  });
})();
